"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FeatureFlags {
    constructor(ff) {
        this._names = new Map();
        this._payloads = new Map();
        this.flags = ff.flags || {};
        this.variants = ff.variants || {};
        this.error = ff.error;
        this._list = FeatureFlags.toArray(this);
    }
    static toArray(ff) {
        return [
            ...Object.keys(ff.flags).filter((flag) => ff.flags[flag]),
            ...Object.keys(ff.variants)
                .filter((flag) => { var _a; return (_a = ff.variants[flag]) === null || _a === void 0 ? void 0 : _a.enabled; })
                .map((flag) => `${flag}:${ff.variants[flag].name}`),
        ];
    }
    getFrom(map, key, callback) {
        if (map.has(key)) {
            return map.get(key);
        }
        const result = callback();
        map.set(key, result);
        return result;
    }
    enabled(key) {
        return !!this.flags[key];
    }
    name(key, defaultValue) {
        return this.getFrom(this._names, key, () => {
            var _a;
            if (this.enabled(key) &&
                this.variants[key] &&
                this.variants[key].enabled &&
                this.variants[key].name) {
                return (_a = this.variants[key]) === null || _a === void 0 ? void 0 : _a.name;
            }
            return defaultValue;
        });
    }
    payload(key, defaultValue) {
        return this.getFrom(this._payloads, key, () => {
            if (this.enabled(key) &&
                this.variants[key] &&
                this.variants[key].enabled &&
                this.variants[key].payload) {
                const { type, value } = this.variants[key].payload;
                switch (type) {
                    case 'json':
                        try {
                            return JSON.parse(value);
                        }
                        catch (e) {
                            console.error(e);
                            return defaultValue;
                        }
                    default:
                        return value;
                }
            }
            return defaultValue;
        });
    }
    list() {
        return this._list;
    }
}
exports.default = FeatureFlags;
